import React from 'react';
import Skeleton from 'react-loading-skeleton';

export type SkeletonBlockProps = {
  lines?: number;
  width?: string;
  height?: string;
  className?: string;
};

export default function SkeletonBlock({
  lines = 3,
  width = '100%',
  height = '1rem',
  className
}: SkeletonBlockProps) {
  return (
    <div className={className} aria-hidden="true">
      {Array.from({ length: lines }).map((_, index) => (
        <Skeleton
          key={index}
          width={width}
          height={height}
          className={index < lines - 1 ? 'mb-sm' : undefined}
        />
      ))}
    </div>
  );
}
